import gql from 'graphql-tag';

export const coverageHoursPairing = gql`
  query coverageHoursPairing(
    $channelId: UUID!
    $category: String!
    $issue: String
  ) {
    coverageHoursPairing(
      channelId: $channelId
      category: $category
      issue: $issue
    ) {
      routingId
      category
      issue
      blocks {
        id
        teamId
        teamName
        daysOfWeek
        startMinute
        endMinute
        timezone
      }
    }
  }
`;
